import React from 'react';
import countries from 'i18n-iso-countries';
countries.registerLocale(require('i18n-iso-countries/langs/en.json'));

import { BillingAddress as BillingAddressType } from 'interfaces/graphql-typings';
export type BillingAddressProps = BillingAddressType['address'] &
  Pick<BillingAddressType, 'email' | 'name'>;

const BillingAddress: React.FC<BillingAddressProps> = ({
  city,
  lineOne,
  lineTwo,
  postalCode,
  state,
  country,
  email,
  name
}): React.ReactElement => (
  <div>
    <div>{name}</div>
    <div>{email}</div>
    <div>{lineOne}</div>
    {lineTwo && <div>{lineTwo}</div>}
    <div>
      {city} {state} {postalCode}
    </div>
    <div>{countries.getName(country, 'en')}</div>
  </div>
);

export default BillingAddress;
